import { useQuery } from "@tanstack/react-query";

import type { MeditationSetupOptionsResponse } from "~/features/meditations/types";

export function useMeditationSetupOptions(
    partInteractionId: string,
    { enabled = true }: { enabled?: boolean } = {},
) {
    return useQuery<MeditationSetupOptionsResponse>({
        queryKey: ["meditation-setup-options", partInteractionId],
        enabled: enabled && partInteractionId.length > 0,
        staleTime: 30_000,
        retry: false,
        queryFn: async () => {
            const url = new URL(
                "/api/meditation/setup-options",
                window.location.origin,
            );
            url.searchParams.set("partInteractionId", partInteractionId);
            const response = await fetch(url.toString(), {
                credentials: "include",
            });
            if (!response.ok) {
                throw new Error(
                    `Meditation setup options failed: ${response.status}`,
                );
            }
            return (await response.json()) as MeditationSetupOptionsResponse;
        },
    });
}
